<template>
  <div class="video_bg">
    <div class="video">
      <h2>云创元宇宙云上展会案例</h2>
      <div class="desc">深耕、专注VR云展，一直走在行业尖端</div>

      <ul class="video_li">
        <div data-aos="flip-up">
          <li>
            <div class="pop1" v-if="!Video_index" @click="play_video">
              <div class="video_cover">
                <img
                  src="../../assets/imges/car3d.png"
                />
              </div>
              <div class="suspend">
                <img src="../../assets/imges/suspend.png" />
              </div>
              <div class="video_p">
                第三十届全国图书交易博览会
              </div>
            </div>
            <div class="video_play" v-show="Video_index">
              <video
                width="100%"
                height="100%"
                id="indexvideo1"
                controls="controls"
                style="object-fit:fill;"
              >
                <source
                  src="https://oss.3dyunchuang.com/home_pic/video/yun3d2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </li>
          <li>
            <div class="pop1" v-if="!Video_index1" @click="play_video1">
              <div class="video_cover">
                <img src="https://oss.3dyunchuang.com/home_pic/video/dwq.jpg" />
              </div>
              <div class="suspend">
                <img src="../../assets/imges/suspend.png" />
              </div>
              <div class="video_p">
                2022大湾区服装服饰博览会
              </div>
            </div>
            <div class="video_play" v-show="Video_index1">
              <video
                width="100%"
                height="100%"
                id="indexvideo2"
                controls="controls"
                style="object-fit:fill;"
              >
                <source
                  src="https://oss.3dyunchuang.com/home_pic/video/dwq.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </li>
        </div>
        <div data-aos="flip-up">
          <li>
            <div class="pop1" v-if="!Video_index2" @click="play_video2">
              <div class="video_cover">
                <img
                  src="https://oss.3dyunchuang.com/home_pic/video/lkimg.jpg"
                />
              </div>
              <div class="suspend">
                <img src="../../assets/imges/suspend.png" />
              </div>
              <div class="video_p">
                第四届临空经济产业展
              </div>
            </div>
            <div class="video_play" v-show="Video_index2">
              <video
                width="100%"
                height="100%"
                id="indexvideo3"
                controls="controls"
                style="object-fit:fill;"
              >
                <source
                  src="https://oss.3dyunchuang.com/home_pic/video/lkvideo.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </li>

          <li>
            <div class="pop1" v-if="!Video_index3" @click="play_video3">
              <div class="video_cover">
                <img
                  src="https://oss.3dyunchuang.com/home_pic/video/xjimg.jpg"
                />
              </div>
              <div class="suspend">
                <img src="../../assets/imges/suspend.png" />
              </div>
              <div class="video_p">
                第三届先进装备制造产业展
              </div>
            </div>
            <div class="video_play" v-show="Video_index3">
              <video
                width="100%"
                height="100%"
                id="indexvideo4"
                controls="controls"
                style="object-fit:fill;"
              >
                <source
                  src="https://oss.3dyunchuang.com/home_pic/video/xjvideo.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </li>
        </div>
      </ul>
    </div>

    <div class="video_footer" @click="SeeMore">
      <h5>查看更多</h5>
      <span></span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //bg的索引
      Video_index: false,
      Video_index1: false,
      Video_index2: false,
      Video_index3: false
    };
  },
  methods: {
    play_video() {
      let video1 = document.getElementById("indexvideo1");
      let video2 = document.getElementById("indexvideo2");
      let video3 = document.getElementById("indexvideo3");
      let video4 = document.getElementById("indexvideo4");
      video4.pause();
      video3.pause();
      video2.pause();
      video1.play();
      this.Video_index3 = false;
      this.Video_index2 = false;
      this.Video_index1 = false;
      this.Video_index = true;
    },
    play_video1() {
      let video1 = document.getElementById("indexvideo1");
      let video2 = document.getElementById("indexvideo2");
      let video3 = document.getElementById("indexvideo3");
      let video4 = document.getElementById("indexvideo4");
      video4.pause();
      video3.pause();
      video2.play();
      video1.pause();
      this.Video_index3 = false;
      this.Video_index2 = false;
      this.Video_index1 = true;
      this.Video_index = false;
    },
    play_video2() {
      let video1 = document.getElementById("indexvideo1");
      let video2 = document.getElementById("indexvideo2");
      let video3 = document.getElementById("indexvideo3");
      let video4 = document.getElementById("indexvideo4");
      video4.pause();
      video3.play();
      video2.pause();
      video1.pause();
      this.Video_index3 = false;
      this.Video_index2 = true;
      this.Video_index1 = false;
      this.Video_index = false;
    },
    play_video3() {
      let video1 = document.getElementById("indexvideo1");
      let video2 = document.getElementById("indexvideo2");
      let video3 = document.getElementById("indexvideo3");
      let video4 = document.getElementById("indexvideo4");
      video4.play();
      video3.pause();
      video2.pause();
      video1.pause();
      this.Video_index3 = true;
      this.Video_index2 = false;
      this.Video_index1 = false;
      this.Video_index = false;
    },

    SeeMore() {
      this.$router.push({
        path: `/scheme`
      });
    }
  }
};
</script>
<style scoped>
.desc {
  padding-top: 12px;
  font-size: 18px;
  color: #666666;
  text-align: center;
}
.video_bg {
  width: 100%;
  height: 1220px;
  background: #f2f6f9;
}
.video h2 {
  padding-top: 90px;
  text-align: center;
  color: #000000;
  font-weight: bold;
  font-size: 32px;
}
.video_li {
  width: 1202px;
  margin: 58px auto 25px;
  overflow: hidden;
}
.pop1 {
  width: 578px;
  height: 370px;
  cursor: pointer;
  overflow: hidden;
}
.video_li .video_play {
  width: 578px;
  height: 370px;
  cursor: pointer;
  overflow: hidden;
}
.video_li li {
  float: left;
  height: 100%;
  width: 578px;
  margin-right: 45px;
  cursor: pointer;
  position: relative;
}
.video_li li:nth-child(1) {
  margin-bottom: 42px;
}
.video_li li:nth-child(2) {
  margin: 0;
}
.video_li li h5 {
  margin-top: 26px;
  font-weight: normal;
  font-size: 24px;
  color: #333132;
  text-align: center;
}
.video_footer {
  cursor: pointer;
  border-radius: 5px;
  color: #357eff;
  width: 318px;
  height: 40px;
  margin: 0px auto;
  border: 1px solid #357eff;
  text-align: center;
  line-height: 40px;
  background-position: 200px center;
}
.video_footer h5 {
  margin-left: 114px;
  float: left;
  font-size: 15px;
  font-weight: normal;
}
.video_footer span {
  width: 25px;
  height: 25px;
  display: block;
  float: left;
  margin-top: 8px;
  margin-left: 8px;
  background: url("../../assets/imges/Right_arrow.png") no-repeat;
  background-size: 100% 100%;
}
.suspend {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 9;
  transform: translate(-50%, -50%);
}

.video_p {
  width: 100%;
  height: 45px;
  background: rgba(25, 25, 25, 0.5);
  position: absolute;
  left: 0;
  bottom: 0px;
  text-align: center;
  line-height: 45px;
  color: #fff;
}
.video_cover img {
  width: 578px;
  height: 370px;
}
</style>



// WEBPACK FOOTER //
// src/common/index/pahe-video.vue